import prognostic from '../prognostics'

const filterDate = {
  container: document.querySelector('[data-component="prognostics-filter-date"]'),
  elements: [],

  addEventListeners: function() {
    this.elements = this.container.querySelectorAll('[data-element-filter-date]')

    if (!this.elements.length) {
      return
    }

    this.elements.forEach(filter => {
      filter.addEventListener('click', this.handleOnClick.bind(this))
    })
  },

  changeActiveClass: function(currentActiveFilterDate) {
    this.elements.forEach(element => {
      element.classList.remove('--is-active')

      if (element.dataset.filterDate == currentActiveFilterDate) {
        element.classList.add('--is-active')
      }
    })
  },

  handleOnClick: function(e) {
    const filterDate = e.target.dataset.filterDate || 'all'
    const activeItem = document.querySelector('.SelectPost-item.active')
    this.changeActiveClass(filterDate)
    prognostic.init({
      filterDate,
      id: activeItem ? activeItem.dataset.id || 0 : 0,
      forceLoad: true,
      perPage: window.innerWidth < 576 ? 3 : 9
    })
  },

  init: function() {
    if (!this.container) {
      return
    }

    this.addEventListeners()
  },
}

filterDate.init()
